
import * as actions from './actionTypes'

export function save(qid, answer) {
  return {
    type: actions.SAVE,
    meta: {id: qid},
    payload: {answer: answer}
  }
}

export function reset() {
  return {
    type: actions.RESET,
  }
}



// WEBPACK FOOTER //
// ./src/question/actions.js